<template>
  <div class="relative w-full h-[600px]">
    <img src="/images/components/image4.jpg" class="w-full h-full object-cover">
    <div class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <h1 class="text-white text-4xl font-medium">Galeria Realizacji</h1>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>